import { render, staticRenderFns } from "./transaction-refund.vue?vue&type=template&id=2f26ff94&scoped=true"
import script from "./transaction-refund.vue?vue&type=script&setup=true&lang=js"
export * from "./transaction-refund.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f26ff94",
  null
  
)

export default component.exports